import { Injectable } from '@angular/core';
import { Api } from '../providers/api/api';
import { RecebeLote } from '../entities/recebe-lote';
import { DefeitoLote } from '../entities/defeito-lote';
import { DefeitoGrupo } from '../entities/defeito-grupo';
import { DTOObterLote } from '../dto/dtoObterLote';


@Injectable()
export class LoteDAO {
    constructor(private _api: Api) { }

    public receberNovoLote(lote: RecebeLote): Promise<any> {
        return new Promise((resolve, reject) => {
            this._api.post('RecebeLote', lote).subscribe(res => {
                resolve(JSON.parse(res._body));
            }, error => {
                reject(error);
            });
        });
    }

    public checarLote(idEmpresa: number,seqLote: number): Promise<RecebeLote> {
        return new Promise((resolve, reject) => {
            this._api.get(`RecebeLote/ChecarLote/${idEmpresa}/${seqLote}`).subscribe(res => {
                if (res)
                    resolve(new RecebeLote().deserialize(JSON.parse(res._body)));
    
                reject('Lote incorretos.');
            }, error => {
                reject(error);
            });
        });
    }

    public liberarLote(lote: RecebeLote): Promise<any> {
        return new Promise((resolve, reject) => {
            this._api.put(`RecebeLote/${lote.Id}`, lote).subscribe(res => {
                resolve(JSON.parse(res._body));
            }, error => {
                reject(error);
            });
        });
    }


    public autorizar(lote: RecebeLote): Promise<any> {
        console.log('teste autorizacao')
        return new Promise((resolve, reject) => {            
            this._api.put(`RecebeLote/AutorizarLote`, lote).subscribe(res => {            
                resolve(JSON.parse(res._body));
            }, error => {
                reject(error);
            });
        });
    }



    public inspecaoNovoLote(defeitoLote: DefeitoLote): Promise<any> {
        return new Promise((resolve, reject) => {
            this._api.post('InspecaoLote', defeitoLote).subscribe(res => {
                resolve(JSON.parse(res._body));
            }, error => {
                reject(error);
            });
        });
    }


    public obterDefeitoGrupo(idEmpresa: number): Promise<DefeitoGrupo[]> {
        return new Promise((resolve, reject) => {
            this._api.get(`DefeitoGrupo/${idEmpresa}`).subscribe(res => {
                resolve(JSON.parse(res._body));
            }, error => {
                reject(error);
            })
        });
    }

    public removerLote(idLote: number): Promise<any> {
        return new Promise((resolve, reject) => {
            this._api.delete(`RecebeLote/${idLote}`).subscribe(res => {
                resolve(JSON.parse(res._body));
            }, error => {
                reject(error);
            });
        });
    }

    public removerDefeito(idDefeito: number): Promise<any> {
        return new Promise((resolve, reject) => {
            this._api.delete(`InspecaoLote/${idDefeito}`).subscribe(res => {
                resolve(JSON.parse(res._body));
            }, error => {
                reject(error);
            });
        });
    }

    public estornoLote(dtoObterLote: DTOObterLote,idUsuario: number): Promise<any> {
        return new Promise((resolve, reject) => {
            dtoObterLote.RecebeLote.Usuario.Id = idUsuario;
            this._api.put(`LoteRecebido/EstornoLote`, dtoObterLote).subscribe(res => {
                resolve(JSON.parse(res._body));
            }, error => {
                reject(error);
            });
        });
    }

    public manterInspecaoLote(lote: RecebeLote): Promise<any> {
        return new Promise((resolve, reject) => {            
            this._api.put(`RecebeLote/InspecaoLote`, lote).subscribe(res => {            
                resolve(JSON.parse(res._body));
            }, error => {
                reject(error);
            });
        });
    }




}



// WEBPACK FOOTER //
// ./src/daos/lote-dao.ts